import { Row, Col, Spinner } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import ReactSelect from 'components/base/ReactSelect';
import { useQuery } from '@tanstack/react-query';
import { AddProductSchema } from './model';
import { getAllCouponByVendor, VendorCoupons } from 'api/coupon/_requests';

type SelectOption = { value: string; label: string };

interface Props {
  vendorId: string;
}

const CouponAddInProduct = ({ vendorId }: Props) => {
  const { control, formState } = useFormContext<AddProductSchema>();

  const { data: coupons, isLoading } = useQuery<VendorCoupons[]>({
    queryKey: ['vendor-coupons', vendorId],
    queryFn: () => getAllCouponByVendor(vendorId),
    enabled: !!vendorId
  });

  const couponOptions: SelectOption[] =
    coupons?.map(c => ({
      value: c._id,
      label: `${c.code}`
    })) ?? [];

  return (
    <Row className="g-2">
      <Col xs={12}>
        {isLoading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <Controller
            name="coupons"
            control={control}
            render={({ field }) => {
              const selected = couponOptions.filter(
                o => field.value?.includes(o.value)
              );

              return (
                <ReactSelect
                  {...field}
                  options={couponOptions}
                  isMulti
                  placeholder="Select one or more coupons"
                  value={selected}
                  onChange={options =>
                    field.onChange(
                      (options as SelectOption[]).map(o => o.value)
                    )
                  }
                />
              );
            }}
          />
        )}

        <div className="text-danger">{formState.errors.coupons?.message}</div>
      </Col>
    </Row>
  );
};

export default CouponAddInProduct;
